import { TFunction } from "i18next";
import * as yup from "yup";
import { SchemaOf } from "yup";

interface otpValidationProps {
  otpRefNo?: string;
}

export const otpValidationSchema = (
  t: TFunction
): SchemaOf<otpValidationProps> =>
  yup.object().shape({
    otpRefNo: yup
      .string()
      .required(t("otp_validation").toString())
      .min(6, t("otp_length_valid").toString()),
  });
